import { Fragment, useEffect, useState } from 'react'
import { FooterButton, ResponsesDrawer, ResponseList, OnList } from './styles'
import { SearchBox } from 'modules/mainmenu/styles'
import { cloneDeep, uniq } from 'lodash'
import apiService from 'utils/apiService'
import { arrayMoveImmutable } from 'array-move'
import { history } from 'store/store'
import { ReactComponent as SearchIcon } from 'assets/images/icons/search24.svg'
import { ReactComponent as InsertIcon } from 'assets/images/icons/insert.svg'
import { colors, FooterActionButtons } from 'modules/app/styles'
import { Button, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import { connect } from 'react-redux'
import { allCategoryIds, consoleLog, handleApiError } from 'utils/helpers'
import { EmptyResultComponent } from '../EmptyResultComponent'
import { EmptyPlaceholder } from '../pages/styles'
import { Link } from 'react-router-dom'
import { getContentByUUID_api, getContents_api } from 'store/apis'
import SortableListContainer from './components/SortableListContainer'
import { changeTab_action, toggleSettingsModal_action, toggleResponsePacksModal_action, saveContent_action, setSortedCategories_action, toggleCategoryModal_action, setIsEditingContentAction, getPrivateAndFavoriteContents_action } from 'store/actions'
import { useCallback } from 'react'
import { PageLoader } from 'utils/storageUtils'
import ConfirmUnsavedResponsePopup from './components/ConfirmUnsavedResponsePopup'
import { useLocation } from 'react-router-dom'

let searchTimeout = null

export const ResponsesTab = (props) => {
  const { responses, setIsEditingContent, getPrivateAndFavoriteContents } = props
  const { uncategorized_private_contents, private_categories, shared_categories } = responses
  // Page states
  const [hoveringSection, set_hoveringSection] = useState('')
  const [searchText, set_searchText] = useState('')
  const [isSearching, set_isSearching] = useState(false)
  const [confirmNavPropup, setConfirmNavPropup] = useState(false)
  const [preExpanded, set_preExpanded] = useState([])
  const [state_shared_categories, set_state_shared_categories] = useState([])
  const [state_uncategorized_private_contents, set_state_uncategorized_private_contents] = useState([])
  const [state_private_categories, set_state_private_categories] = useState([])
  useEffect(() => set_state_shared_categories(shared_categories), [shared_categories])
  useEffect(() => {
    set_state_uncategorized_private_contents(uncategorized_private_contents)
  }, [uncategorized_private_contents])
  useEffect(() => set_state_private_categories(private_categories), [private_categories])
  // Sorting
  const onSortEnd = ({ oldIndex, newIndex, collection }, category_id, _responses, categories, sharing_type) => {
    if (collection === 'sorting-responses') {
      onResponsesSortEnd({ oldIndex, newIndex, collection }, category_id, _responses, categories, sharing_type)
    } else if (collection.includes('sorting-categories')) {
      let parent_id = collection.split('-')
      parent_id = parent_id[2] || null
      onResponseCategorySortEnd({ oldIndex, newIndex }, parent_id, categories, sharing_type)
    }
  }

  const { pathname } = useLocation()

  const onResponsesSortEnd = async ({ oldIndex, newIndex }, category_id, _responses, categories, sharing_type) => {
    const _hoveringSection = hoveringSection.split('-')
    const hoveredSectionId = parseInt(_hoveringSection[1])
    // moving non-category to non-category or within category
    if ((!category_id && !hoveredSectionId) || category_id === hoveredSectionId) {
      if (oldIndex !== newIndex) {
        if (!category_id) {
          // non-category to non-category
          // Local changes
          const sorted = arrayMoveImmutable(_responses, oldIndex, newIndex)
          set_state_uncategorized_private_contents(sorted)
          // Server changes
          saveSortedResponses(sorted)
        } else {
          // within category
          // Local changes
          const cat_index = categories.map((c) => c.id).indexOf(category_id)
          if (cat_index !== -1) {
            categories[cat_index].contents = arrayMoveImmutable(categories[cat_index].contents, oldIndex, newIndex)
            // Server changes
            saveSortedResponses(categories[cat_index].contents, category_id)
          } else {
            // Search in sub_categories
            for (const cat_index in categories) {
              const sub_cat_index = categories[cat_index].subcategories.map((c) => c.id).indexOf(category_id)
              if (sub_cat_index !== -1) {
                categories[cat_index].subcategories[sub_cat_index].contents = arrayMoveImmutable(categories[cat_index].subcategories[sub_cat_index].contents, oldIndex, newIndex)
                // Server changes
                saveSortedResponses(categories[cat_index].subcategories[sub_cat_index].contents, category_id)
                break
              } else {
                // Search in sub_categories
                for (const sub_cat_index in categories[cat_index].subcategories) {
                  const sub_sub_cat_index = categories[cat_index].subcategories[sub_cat_index].subcategories.map((c) => c.id).indexOf(category_id)
                  if (sub_sub_cat_index !== -1) {
                    categories[cat_index].subcategories[sub_cat_index].subcategories[sub_sub_cat_index].contents = arrayMoveImmutable(
                      categories[cat_index].subcategories[sub_cat_index].subcategories[sub_sub_cat_index].contents,
                      oldIndex,
                      newIndex
                    )
                    // Server changes
                    saveSortedResponses(categories[cat_index].subcategories[sub_cat_index].subcategories[sub_sub_cat_index].contents, category_id)
                    break
                  }
                }
              }
            }
          }
          if (sharing_type === 'shared_categories') {
            set_state_shared_categories([...categories])
          } else if (sharing_type === 'private_categories') {
            set_state_private_categories([...categories])
          }
        }
      }
    } else if (!category_id && hoveredSectionId) {
      // moving non-category to category (happens for Private only)
      // Server changes
      const _allCategoryIds = allCategoryIds(private_categories)
      if (_allCategoryIds.includes(hoveredSectionId)) {
        const newResponse = await getContentByUUID_api(_responses[oldIndex].uuid)
        let i = categories.map((c) => c.id).indexOf(hoveredSectionId)
        if (i !== -1) {
          categories[i].contents.push(_responses[oldIndex])
          newResponse.category = { label: categories[i].name, value: categories[i].id }
          newResponse.category_id = categories[i].id
        } else {
          // Search in sub_categories
          for (const sub_cat_index in categories) {
            i = categories[sub_cat_index].subcategories.map((c) => c.id).indexOf(hoveredSectionId)
            if (i !== -1) {
              categories[sub_cat_index].subcategories[i].contents.push(_responses[oldIndex])
              newResponse.category = { label: categories[sub_cat_index].subcategories[i].name, value: categories[sub_cat_index].subcategories[i].id }
              newResponse.category_id = categories[sub_cat_index].subcategories[i].id
              break
            }
          }
        }

        // Local changes
        // Remove response from non-category
        const _state_uncategorized_private_contents = cloneDeep(state_uncategorized_private_contents)
        const response_i = _state_uncategorized_private_contents.map((c) => c.id).indexOf(_responses[oldIndex].id)
        _state_uncategorized_private_contents.splice(response_i, 1)
        set_state_uncategorized_private_contents(_state_uncategorized_private_contents)
        set_state_private_categories([...categories])
        props.saveContent(newResponse)
      }
    } else if (category_id && !hoveredSectionId) {
      // moving category to non-category
      const _state_uncategorized_private_contents = cloneDeep(state_uncategorized_private_contents)
      let _response = {}
      let i = categories.map((c) => c.id).indexOf(category_id)
      if (i !== -1) {
        _response = { ...categories[i].contents[oldIndex] }
        _state_uncategorized_private_contents.push(_response)

        const old_response_i = categories[i].contents.map((c) => c.id).indexOf(_response.id)
        categories[i].contents.splice(old_response_i, 1)
      } else {
        for (const sub_cat_index in categories) {
          i = categories[sub_cat_index].subcategories.map((c) => c.id).indexOf(category_id)
          if (i !== -1) {
            _response = { ...categories[sub_cat_index].subcategories[i].contents[oldIndex] }
            _state_uncategorized_private_contents.push(_response)
            const old_response_i = categories[sub_cat_index].subcategories[i].contents.map((c) => c.id).indexOf(_response.id)
            categories[sub_cat_index].subcategories[i].contents.splice(old_response_i, 1)
          }
        }
      }

      // Local changes
      set_state_uncategorized_private_contents(_state_uncategorized_private_contents)
      if (sharing_type === 'shared_categories') {
        set_state_shared_categories([...categories])
      } else if (sharing_type === 'private_categories') {
        set_state_private_categories([...categories])
      }

      // Server changes
      if (_response.uuid) {
        const newResponse = await getContentByUUID_api(_response.uuid)
        newResponse.category = { label: '', value: null }
        newResponse.category_id = null
        props.saveContent(newResponse)
      }
    } else if (category_id && hoveredSectionId) {
      // inter-category moving
      let newResponse = {}
      let srcCat_i = categories.map((c) => c.id).indexOf(category_id)
      let destCat_i = categories.map((c) => c.id).indexOf(hoveredSectionId)
      if (srcCat_i !== -1 && destCat_i !== -1) {
        // If source and destination are root categories
        newResponse = await getContentByUUID_api(categories[srcCat_i].contents[oldIndex].uuid)
        newResponse.category = { label: categories[destCat_i].name, value: categories[destCat_i].id }
        newResponse.category_id = categories[destCat_i].id

        categories[srcCat_i].contents.splice(oldIndex, 1)

        categories[destCat_i].contents.push(newResponse)
      } else {
        for (const cat_index in categories) {
          if (srcCat_i !== -1 && destCat_i === -1) {
            // If source is root and destination is sub category
            destCat_i = categories[cat_index].subcategories.map((c) => c.id).indexOf(hoveredSectionId)
            if (destCat_i !== -1) {
              newResponse = await getContentByUUID_api(categories[srcCat_i].contents[oldIndex].uuid)
              newResponse.category = { label: categories[cat_index].subcategories[destCat_i].name, value: categories[cat_index].subcategories[destCat_i].id }
              newResponse.category_id = categories[cat_index].subcategories[destCat_i].id

              categories[srcCat_i].contents.splice(oldIndex, 1)
              categories[cat_index].subcategories[destCat_i].contents.push(newResponse)
              break
            }
          } else if (srcCat_i === -1 && destCat_i !== -1) {
            // If source is not root category and destination is root category
            // search for the source in sub_categories
            srcCat_i = categories[cat_index].subcategories.map((c) => c.id).indexOf(category_id)
            if (srcCat_i !== -1) {
              newResponse = await getContentByUUID_api(categories[cat_index].subcategories[srcCat_i].contents[oldIndex].uuid)
              newResponse.category = { label: categories[destCat_i].name, value: categories[destCat_i].id }
              newResponse.category_id = categories[destCat_i].id
              categories[cat_index].subcategories[srcCat_i].contents.splice(oldIndex, 1)
              categories[destCat_i].contents.push(newResponse)
              break
            }
          } else if (srcCat_i === -1 && destCat_i === -1) {
            // If source and destination are sub categories
            srcCat_i = categories[cat_index].subcategories.map((c) => c.id).indexOf(category_id)
            destCat_i = categories[cat_index].subcategories.map((c) => c.id).indexOf(hoveredSectionId)
            if (srcCat_i !== -1 && destCat_i !== -1) {
              newResponse = await getContentByUUID_api(categories[cat_index].subcategories[srcCat_i].contents[oldIndex].uuid)
              newResponse.category = { label: categories[cat_index].subcategories[destCat_i].name, value: categories[cat_index].subcategories[destCat_i].id }
              newResponse.category_id = categories[cat_index].subcategories[destCat_i].id
              categories[cat_index].subcategories[srcCat_i].contents.splice(oldIndex, 1)
              categories[cat_index].subcategories[destCat_i].contents.push(newResponse)
              break
            }
          }
        }
      }

      // Local changes
      if (sharing_type === 'shared_categories') {
        set_state_shared_categories([...categories])
      } else if (sharing_type === 'private_categories') {
        set_state_private_categories([...categories])
      }

      // Server changes
      if (newResponse.id) {
        props.saveContent(newResponse)
      }
    }
  }
  const saveSortedResponses = async (responses, category_id) => {
    try {
      const sortedIndexes = responses.map((r, i) => ({ order: i, id: r.id }))
      const data = {
        sortedIndexes: JSON.stringify(sortedIndexes),
        category_id,
        _method: 'patch'
      }
      await apiService(`contents/sort`, data, 'post', true)
    } catch (error) {
      handleApiError(error)
    }
  }

  const onResponseCategorySortEnd = ({ oldIndex, newIndex }, parent_id, categories, sharing_type) => {
    if (oldIndex !== newIndex) {
      // Local changes

      let _categories = [...responses[sharing_type]]

      if (parent_id) {
        const i = _categories.findIndex((c) => c.id === parseInt(parent_id))
        if (i !== -1) {
          _categories[i].subcategories = arrayMoveImmutable(_categories[i].subcategories, oldIndex, newIndex)
          // Server changes
          saveSortedCategories(_categories[i].subcategories)
        }
      } else {
        _categories = arrayMoveImmutable(_categories, oldIndex, newIndex)
        // Server changes
        saveSortedCategories(_categories)
      }

      if (sharing_type === 'shared_categories') {
        set_state_shared_categories(_categories)
      } else if (sharing_type === 'private_categories') {
        set_state_private_categories(_categories)
      }
      props.setSortedCategories(_categories, sharing_type)
    }
  }
  const saveSortedCategories = async (sorted_categories) => {
    try {
      const sortedIndexes = sorted_categories.map((r, i) => ({ order: i, id: r.id }))
      const data = {
        sortedIndexes: JSON.stringify(sortedIndexes),
        _method: 'patch'
      }
      await apiService('contents/categories/sort', data, 'post', true)
    } catch (error) {
      handleApiError(error)
    }
  }

  const setIsHoveringSection = (section) => {
    set_hoveringSection(section)
  }
  // End Sorting

  const searchData = useCallback(
    async (search) => {
      if (search?.trim()) {
        try {
          const _preExpanded = []
          set_isSearching(true)

          const contents = await getContents_api({ search, type: 'response' })
          const _uncategorized_private_contents = contents.filter((item) => !item.category_id)

          const categorized_contents = contents.filter((item) => item.category_id)
          let rootCategories = []
          for (const content of categorized_contents) {
            if (content.category?.parent_category?.parent_category) {
              const i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.parent_category?.id)
              if (i === -1) {
                rootCategories.push({
                  ...content.category?.parent_category?.parent_category,
                  contents: [],
                  subcategories: []
                })
              }
            } else if (content.category?.parent_category) {
              const i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.id)
              if (i === -1) {
                rootCategories.push({
                  ...content.category?.parent_category,
                  contents: [],
                  subcategories: []
                })
              }
            } else if (content.category) {
              const i = rootCategories.findIndex((cat) => cat.id === content.category?.id)
              if (i === -1) {
                rootCategories.push({
                  ...content.category,
                  contents: [],
                  subcategories: []
                })
              }
            }

            // Check content.category is a root category
            const i = rootCategories.findIndex((cat) => cat.id === content.category?.id)
            if (i !== -1) {
              rootCategories[i].contents.push(content)
              _preExpanded.push(`cat_${content.category?.uuid}`)
            } else {
              // If NOT content.category is a root category
              // Check if content.category.parent_category is a root category
              const root_i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.id)
              if (root_i !== -1) {
                // If root category found, then find the subcategory for content.category.parent_category
                const sub_cat_i = rootCategories[root_i].subcategories.findIndex((cat) => cat.id === content.category?.id)
                if (sub_cat_i !== -1) {
                  rootCategories[root_i].subcategories[sub_cat_i].contents.push(content)
                  _preExpanded.push(`cat_${rootCategories[root_i]?.uuid}`)
                  _preExpanded.push(`cat_${rootCategories[root_i]?.subcategories[sub_cat_i]?.uuid}`)
                } else {
                  rootCategories[root_i].subcategories.push({
                    ...content.category,
                    subcategories: [],
                    contents: [content]
                  })
                  _preExpanded.push(`cat_${content.category?.uuid}`)
                }
                _preExpanded.push(`cat_${rootCategories[root_i].uuid}`)
              } else {
                // If NOT content.category.parent_category is a root category
                // Check if content.category.parent_category.parent_category is a root category
                const root_i = rootCategories.findIndex((cat) => cat.id === content.category?.parent_category?.parent_category?.id)
                if (root_i !== -1) {
                  // if root category, then find the subcategory of content.category?.parent_category?.id
                  const sub_cat_i = rootCategories[root_i].subcategories.findIndex((cat) => cat.id === content.category?.parent_category?.id)
                  // If found the subcategory, then find the sub_subcategory of content.category.id
                  if (sub_cat_i !== -1) {
                    const sub_sub_cat_i = rootCategories[root_i].subcategories[sub_cat_i].subcategories.findIndex((cat) => cat.id === content.category?.id)
                    // If found the sub sub category, then push the contents into sub sub category
                    if (sub_sub_cat_i !== -1) {
                      rootCategories[root_i].subcategories[sub_cat_i].subcategories[sub_sub_cat_i].contents.push(content)
                    } else {
                      rootCategories[root_i].subcategories[sub_cat_i].subcategories.push({
                        ...content.category,
                        contents: [content],
                        subcategories: []
                      })
                    }
                    _preExpanded.push(`cat_${content.category?.uuid}`)
                  } else {
                    // If not found the sub sub category, push in sub category
                    rootCategories[root_i].subcategories.push({
                      ...content.category?.parent_category,
                      contents: [],
                      subcategories: [
                        {
                          ...content.category,
                          contents: [content],
                          subcategories: []
                        }
                      ]
                    })
                    _preExpanded.push(`cat_${content.category?.parent_category?.uuid}`)
                    _preExpanded.push(`cat_${content.category?.uuid}`)
                  }
                  _preExpanded.push(`cat_${rootCategories[root_i].uuid}`)
                }
              }
            }
          }
          const _shared_categories = rootCategories.filter((cat) => cat.shared_users.length)
          const _private_categories = rootCategories.filter((cat) => !cat.shared_users.length)

          set_state_uncategorized_private_contents(_uncategorized_private_contents)
          set_state_private_categories(_private_categories)
          set_state_shared_categories(_shared_categories)
          set_preExpanded(uniq(_preExpanded))
        } catch (error) {
          consoleLog(error)
        }
        set_isSearching(false)
      } else {
        set_preExpanded([])
        set_state_uncategorized_private_contents(uncategorized_private_contents)
        set_state_shared_categories(shared_categories)
        set_state_private_categories(private_categories)
      }
    },
    [uncategorized_private_contents, private_categories, shared_categories]
  )

  useEffect(() => {
    clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => searchData(searchText), 500)
  }, [searchText, searchData])

  useEffect(() => {
    setTimeout(() => {
      if(pathname === '/'){
        set_preExpanded(shared_categories?.map(cat => cat?.uuid))
      }
    }, 100)
    
    getPrivateAndFavoriteContents({ type: 'response' });
    
  }, [getPrivateAndFavoriteContents, pathname]);

  return (
    <Fragment>
      <SearchBox>
        <SearchIcon stroke={colors['text-secondary']} className='searchIcon' />
        <input type='text' className='SearchInput' placeholder='Search your Responses' onChange={(e) => set_searchText(e.target.value)} value={searchText} />
      </SearchBox>
      <ResponsesDrawer>
        <ResponseList id='responseScrollDiv'>
          {isSearching && (
            <div className='d-flex justify-content-center'>
              <div>
                <PageLoader />
                Searching for <b>{searchText}...</b>
              </div>
            </div>
          )}
          {!isSearching && searchText && state_uncategorized_private_contents.length + state_private_categories.length + state_shared_categories.length === 0 && <EmptyResultComponent />}
          {!isSearching && state_uncategorized_private_contents.length + state_private_categories.length + state_shared_categories.length > 0 && (
            <>
              {/* Private */}
              {state_uncategorized_private_contents.length + state_private_categories.length > 0 && (
                <div className='py-3'>
                  <h5 className='mx-3'>
                    <small className='section-name text-muted font-weight-600'> Private</small>
                  </h5>
                  {state_uncategorized_private_contents.length + state_private_categories.length === 0 && (
                    <ul>
                      <OnList className='pl-3'>
                        <EmptyPlaceholder className='text-muted small'>
                          <Link to={`/responses/create`}>
                            <InsertIcon /> Create a response
                          </Link>
                        </EmptyPlaceholder>
                      </OnList>
                    </ul>
                  )}
                  {/* Categorized */}
                  {state_uncategorized_private_contents.length + state_private_categories.length > 0 && (
                    <SortableListContainer
                      searchText={searchText}
                      isPrivate={true}
                      preExpanded={preExpanded}
                      onSortEnd={(indexes) => onSortEnd(indexes, null, state_uncategorized_private_contents, state_private_categories, 'private_categories')}
                      onCategorizedResponsesSortEnd={(indexes, category_id) => onSortEnd(indexes, category_id, state_uncategorized_private_contents, state_private_categories, 'private_categories')}
                      setIsHoveringSection={setIsHoveringSection}
                      hoveringSection={hoveringSection}
                      response_categories={state_private_categories}
                      allResponses={state_uncategorized_private_contents}
                      hideAddResponse={true}
                      helperClass='sorting-item'
                      useDragHandle
                    />
                  )}
                </div>
              )}
              {/* Shared categories */}
              {state_shared_categories.length > 0 && (
                <div className='py-3'>
                  <h5 className='mb-0 mx-3'>
                    <small className='section-name text-muted font-weight-600'> Shared</small>
                  </h5>
                  <SortableListContainer
                    searchText={searchText}
                    isPrivate={false}
                    preExpanded={preExpanded}
                    onSortEnd={(indexes) => onSortEnd(indexes, null, [], state_shared_categories, 'shared_categories')}
                    onCategorizedResponsesSortEnd={(indexes, category_id) => onSortEnd(indexes, category_id, [], state_shared_categories, 'shared_categories')}
                    setIsHoveringSection={setIsHoveringSection}
                    hoveringSection={hoveringSection}
                    response_categories={state_shared_categories}
                    allResponses={[]}
                    hideAddResponse={true}
                    helperClass='sorting-item'
                    useDragHandle
                  />
                </div>
              )}
            </>
          )}
        </ResponseList>
        <ConfirmUnsavedResponsePopup open={confirmNavPropup} setOpen={(val) => {
          val && setIsEditingContent(val);
          setConfirmNavPropup(val)
        }} />
        <FooterButton>
          <FooterActionButtons>
            <Button
              onClick={() => {
                if (!props.isFree && !props.isOnGracePeriod && !props.is_subscribed && props.total_items_count >= props.free_items_limit) {
                  props.toggleSettingsModal(true)
                  props.changeTab('billing')
                  history.push('/')
                } else {
                  if (props.isEditingStatus && (pathname.startsWith('/responses/create') || pathname.startsWith('/responses/edit'))) {
                    setConfirmNavPropup(true)
                  } else {
                    history.push('/responses/create')
                  }
                }
              }}>
              <InsertIcon fill={colors['main-blue']} /> New Response
            </Button>
            <DropdownToggle split />
            <DropdownMenu right>
              <DropdownItem onClick={() => props.toggleResponsePacksModal(true)} className='dropdown-button'>
                Response Packs
              </DropdownItem>
              <DropdownItem onClick={() => props.toggleCategoryModal(true, { type: 'response' })} className='dropdown-button'>
                New Category
              </DropdownItem>
            </DropdownMenu>
          </FooterActionButtons>
        </FooterButton>
      </ResponsesDrawer>
    </Fragment>
  )
}

const mapStateToProps = (state) => ({
  responses: state.contents.responses,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  isFree: state.company.company.isFree,
  is_subscribed: state.subscription.is_subscribed,
  free_items_limit: state.company.company.free_items_limit,
  total_items_count: state.app.total_items_count,
  isEditingStatus: state.contents.isEditingContent
})

const mapDispatchToProps = (dispatch) => ({
  saveContent: (data) => new Promise((resolve, reject) => dispatch(saveContent_action(data, resolve, reject))),
  toggleCategoryModal: (status, item) => dispatch(toggleCategoryModal_action(status, item)),
  toggleResponsePacksModal: (data) => dispatch(toggleResponsePacksModal_action(data)),
  toggleSettingsModal: (status) => dispatch(toggleSettingsModal_action(status)),
  setSortedCategories: (data, category_type) => dispatch(setSortedCategories_action(data, category_type)),
  changeTab: (value) => dispatch(changeTab_action(value)),
  setIsEditingContent: (isEditingStatus) => dispatch(setIsEditingContentAction(isEditingStatus)),
    getPrivateAndFavoriteContents: (filter) => dispatch(getPrivateAndFavoriteContents_action(filter))

})
export default connect(mapStateToProps, mapDispatchToProps)(ResponsesTab)
